import styled from "styled-components";

export const NotificationMessage = styled("span")``;
